export default "__VITE_ASSET__6tp$FM4D__"